// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-activation[data-v-d899acac]{display:block;width:150px; height:40px !important; margin:8px auto 0; background:#e27070 !important; color:#fff; border-radius:5px; font-size:var(--font16);}\n", ""]);
// Exports
module.exports = exports;
